import type { IMember } from '@/api/members/types'

export default defineNuxtRouteMiddleware((to) => {
  const member = useState<IMember | null>('currentMember')
  if (member.value?.password_renew_request && !to.path.includes('/member/')) {
    const localePath = useLocalePath()
    return navigateTo(localePath('/member/passwd'))
  }
})
